import React, { useEffect, useState } from 'react'
import UsiDetailsForm from '../tags/UsiDetailsForm'
import parse from 'html-react-parser';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getHelperTextForPage, getTemporaryCustomMessages } from '../../services/reservoir'
import HelpText from '../tags/HelpText'
import { getUsiDetails, putUsiDetails } from '../../services/vu'
import { Notifications } from '@mui/icons-material'

import Loading from '../tags/Loading'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, personalDetails }) => {
  return {
    personalDetails: personalDetails.data,
    isOffshoreFlag: selectedCourse.isOffshoreFlag
  }
}

const UsiDetails = props => {

  const [formLoaded, setFormLoaded] = useState(false)
  const [saving, setSaving] = useState(false)
  const [topCallout, setTopCallout] = useState('')
  const [usiVerificationSuccess, setUsiVerificationSuccess] = useState(false)
  const [tempMessage, setTempMessage] = useState(null);
  const [form, setForm] = useState({
    dateOfBirth: '',
    singleName: '',
    firstName: '',
    familyName: '',
    usiNo: '',
    firstFamilyNameIndicator: 'N',
    usiVerified: false
  })

  useEffect(()=> {
    Promise.all([getUsiDetails(),getHelperTextForPage('Usi Details'),, getTemporaryCustomMessages('USI_OUTAGE')]).then(([usiDetails, helperText, tempMessages]) => {
      setTopCallout(helperText.length > 0 ? helperText[0].attributes.body.value : topCallout)

      if (props.personalDetails.legalLastName !== null && props.personalDetails.legalLastName !== '') {
        usiDetails.firstFamilyNameIndicator = 'Y'
      }
      if (usiDetails.validationOutcome === 'VALID') {
        usiDetails.usiVerified = true
      }

      const updatedForm = {
        ...form,
        ...usiDetails,
        ...props.personalDetails,
        offshoreFlag: props.isOffshoreFlag
      };

      setForm(updatedForm);
      setFormLoaded(true);
      setTempMessage(tempMessages.length ? tempMessages[0] : null);
    })
  },[props.personalDetails, props.isOffshoreFlag])

  const handleSubmit = form => {

    let newUsiDetails = {
      studentId: form.studentId,
      usiNo: form.usiNo,
      givenName: form.legalFirstName,
      surname: form.legalLastName,
      singleName: form.singleName,
      gender: form.gender,
      dateOfBirth: form.dateOfBirth
    }

    setSaving(true)

    putUsiDetails(newUsiDetails)
    .then(() => {
      setUsiVerificationSuccess(true)
      setSaving(false)
    })
    .catch(({ response: { status, data: { errorCode, errorMessage } } }) => {
      setSaving(false)

      if (status === 400) {
        alert(errorMessage)
      } else {
        alert('System has encountered an error. Please try again or contact VUHQ for assistance.')
      }
    });   
  }

  return (
    <div className="page">
      <div className="row">
        <div className="col-xs-12">
          <div className="settings-container">
            <HelpText tag={'h2'} text={'USI details'} />
            {tempMessage ? (
              <div className="tile-notification" style={{ maxWidth: 800, margin: '20px auto' }}>
                <div className="tile-content">
                  <h2>
                    <Notifications class="btn-point-events" /> {tempMessage.title}
                  </h2>
                  {parse(tempMessage.value)}
                </div>
              </div>
            ) : null}
            {formLoaded && !form.usiVerified && parse(topCallout)}
            {!formLoaded ? (
              <Loading />
            ) : (
              <UsiDetailsForm
                saving={saving}
                values={form}
                handleSubmit={handleSubmit}
                usiVerificationSuccess={usiVerificationSuccess}
              />
            )}
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(connect(mapStateToProps)(UsiDetails))